<div class="container-fluid p-0">
  <div class="row">
    <div class="col-12">
      <div class="login-card">
        <div>
          <div>
            <a class="logo" routerLink="/"><h2>Панель керування</h2></a>
          </div>
          <div class="login-main">
            <form class="theme-form" [formGroup]="loginForm">
              <h4>Вхід</h4>
              <div class="form-group">
                <label class="col-form-label">Email</label>
                <input class="form-control" type="email" required="" formControlName="login" />
                <div *ngIf="loginForm.controls.login.touched && loginForm.controls.login.errors?.required" class="text text-danger mt-1">E-Mail ist erforderlich</div>
              </div>
              <div class="form-group">
                <label class="col-form-label">Пароль</label>
                <input class="form-control" [type]="show ? 'text' : 'password'" formControlName="password" required="" />
              </div>
              <div class="form-group mb-0">
                <!-- <a [routerLink]="'/authentication/forgot-password'" class="link">Passwort vergessen?</a> -->
                <div class="text-end mt-3">
                  <button class="btn btn-primary d-block w-100" [disabled]="!loginForm.valid" (click)="login()" type="button"><span>Увійти</span></button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
